/**
 * Normalises an email address the same way the backend's EmailUtil.sanitizeEmail does: strips
 * whitespace and invisible characters, then lower-cases.
 *
 * A plain .trim() is not enough. It leaves a non-breaking space (U+00A0), a zero-width space
 * (U+200B), a byte-order mark (U+FEFF) and a left-to-right mark (U+200E) exactly where they were,
 * and those arrive constantly from addresses pasted out of Word, Excel and PDFs. The address then
 * looks perfectly correct on screen while the email validator rejects it, with nothing visible to
 * explain why — which is the support call this prevents.
 *
 * Whitespace is removed everywhere, not just at the ends, because an unquoted address cannot
 * contain a space at any position. Characters that ARE legal in an address are left alone.
 */
export function sanitizeEmail(email: string | null | undefined): string {
    if (!email) {
        return ''
    }
    // \p{Z} = every Unicode separator, \p{C} = control, format, unassigned, private-use, surrogate
    return email.replace(/[\p{Z}\p{C}]/gu, '').toLowerCase()
}
